<template>
  <div>
    <!-- <v-text-field hide-details="" append-icon="mdi-calendar" dense v-model="date" solo class="custom-input"/> -->

    <date-picker
      class="datepicker"
      ref="dialog"
      v-model="date"
      :placeholder="label"
      :color="
        this.$vuetify.theme.dark
          ? this.$vuetify.theme.themes.dark.primary
          : this.$vuetify.theme.themes.light.primary
      "
      :wrapper-submit="true"
      append-to="body"
      :locale="$i18n.locale"
      :localeConfig="{
        fa: {
          //dow: 6,
          dir: 'rtl',
        },
        en: {
          dir: 'ltr',
        },
      }"
      :disabled="disabled"
      :popover="false"
      :input-attrs="{ style: { width: '100% !important' } }"
    ></date-picker>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import TextUtils from "../../utils/TextUtils";
import DateUtils from "../../utils/DateUtils";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    label: String,
    initDate: String,
    disabled: {
      type: Boolean,
      default:false
    },
  },
  mounted() {
    ////console.log('initDate:'+this.initDate)
    // //debugger
    this.date = this.fixDate(this.initDate);
  },
  data: () => ({
    date: "",
    modal: false,
  }),
  computed: {
    maxDate() {

      let today = new Date().toLocaleDateString("fa-IR");

      var max = TextUtils.convertToEnglishDigits(today);
      ////console.log(max);
      return max;
    },
  },
  methods: {
    dateResult() {
      //this.$refs.dialog.save(this.date);
      this.$emit("dateResult", this.date);
    },
    fixDate(date) {
      var d = "";
      if (date && date != "") {
        d = DateUtils.fixDateFormatTwoDigit(date.toString());
      } else {
        d = DateUtils.fixDateFormatTwoDigit(
          new Date().toLocaleDateString("fa-IR").toString()
        );
      }
      var res = TextUtils.convertToEnglishDigits(d);
      return res;
    },
  },
  watch: {
    initDate() {
      this.date = this.fixDate(this.initDate);
    },
    date() {
      this.dateResult();
    },
  },
};
</script>

<style>
.datepicker {
}
</style>